import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
} from "@mui/material";
import ModalNuevaEtapa from "../EtapaProcesal/ModalNuevaEtapa";
import AppContext from "../../../../Context/AppContext";
import SubEtapas from "./SubEstapas";
import Archivos from "./Archivos";
import "./ModalEtapa1.css";

const ModalEtapa1 = ({
  show,
  setShow,
  currentDemanda,
  currentEtapa,
  cmbTipoJuicio,
  cmbJuzgados,
  loadInfoParent,
}) => {
  const { checkUserSession, contextAcreditado, changeLoading } =
    useContext(AppContext);
  const [showModalNuevaEtapa, setShowModalNuevaEtapa] = useState(false);
  const [showEtapas, setShowEtapas] = useState(true);
  const [currentNuevaEtapa, setCurrentNuevaEtapa] = useState({});
  const acreditadoInfo = contextAcreditado.getInfoAcreditado();
  const [currentTab, setCurrentTab] = useState(0);

  function setUpdateEtapa(item) {
    setCurrentNuevaEtapa({
      ...item,
      AsigDEFechaInicio: item.AsigDefechaInicio,
      AsigDEFechaFinal: item.AsigDefechaFinal,
      AsigDEComentarios: item.AsigDecomentarios,
      exist: true,
    });
    setShowModalNuevaEtapa(true);
  }
  function reloadEtapas() {
    setShowEtapas(false);
    setShowModalNuevaEtapa(false);
    setShowEtapas(true);
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName={`modal-90wEtapa1  `}
        className={`ModalEtapa1 ${showModalNuevaEtapa && "ModalDemandasHide"}`}
      >
        <h1 className="ModelEtapa1_titulo">
          Editar :
          <span className="ModelEtapa1_Subtitulo">
            {currentEtapa.EtaDescripcion}
          </span>
        </h1>
        <br />

        <h5 className="ModelEtapa1_text">
          Rellene los campos y pulse guardar.
        </h5>
        <br />

        <Modal.Body>
          <div className="ModelEtapa1_Expediente">
            <div>
              Núm. Expediente:
              <h5 className="ModelEtapa1_Expediente_color">
                {acreditadoInfo.AcreditadoId}
              </h5>
            </div>
            <div>
              Nombre:
              <h5 className="ModelEtapa1_Expediente_color">
                {acreditadoInfo.Nombreac}
              </h5>
            </div>
          </div>

          <div className="ModelEtapa1_Acreditado">
            <div>
              <TextField
                id="outlined-basic"
                label="Exp. Judicial"
                variant="outlined"
                disabled
                value={currentDemanda["AsigDfolioDemanda"]}
                fullWidth
              />
            </div>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Núm. de Juzgado
              </InputLabel>
              <Select
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                disabled
                label={
                  <div className="cmbTipoGestionTitle">Núm. de Juzgado</div>
                }
                value={currentDemanda.JuzgadoId}
              >
                {cmbJuzgados.map((item) => (
                  <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Tipo de juicio
              </InputLabel>
              <Select
                required
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                disabled
                label={
                  <div className="cmbTipoGestionTitle">Tipo de juicio</div>
                }
                value={currentDemanda.TipoJuicioId}
              >
                {cmbTipoJuicio.map((item) => (
                  <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="menuTab_AcreditadoDetalle">
            <div
              className={
                currentTab === 0 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(0)}
            >
              Etapas
            </div>
            <div
              className={
                currentTab === 1 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(1)}
            >
              Archivos
            </div>
          </div>
          {currentTab === 0 && (
            <div className="ModalEtapa1_subEtapasContainer">
              <div className="modalAdicion__buttoncontainer">
                <button
                  className="modalAdicion__btnRegistrar"
                  type="button"
                  onClick={() => {
                    setCurrentNuevaEtapa({
                      AsigDemandaId: currentEtapa.etapaInfo.AsigDemandaId,
                      exist: null,
                      EtapaId: currentEtapa.EtapaId,
                    });
                    setShowModalNuevaEtapa(true);
                  }}
                >
                  Registrar nueva etapa
                </button>
              </div>
              {showEtapas && (
                <SubEtapas
                  currentDemanda={currentDemanda}
                  currentEtapa={currentEtapa}
                  setCurrentNuevaEtapa={setUpdateEtapa}
                />
              )}
            </div>
          )}
          {currentTab === 1 && (
            <Archivos
              currentDemanda={currentDemanda}
              currentEtapa={currentEtapa}
            />
          )}
        </Modal.Body>
      </Modal>
      {showModalNuevaEtapa && (
        <ModalNuevaEtapa
          show={showModalNuevaEtapa}
          setShow={setShowModalNuevaEtapa}
          currentEtapa={currentNuevaEtapa}
          loadInfoParent={reloadEtapas}
        />
      )}
    </>
  );
};

export default ModalEtapa1;
